import React, { useEffect, useState } from 'react';
import apiSafibc from '../../axios/axios';

const Encuesta = () => {
    const [paso, setPaso] = useState(0);
    const [respuestas, setRespuestas] = useState({
        recomendacion: '',
        expectativas: '',
        satisfaccion: '',
        observaciones: ''
    });
    const [enviada, setEnviada] = useState(false);

    useEffect(() => {
        const yaRespondio = localStorage.getItem('encuestaRespondida');
        if (yaRespondio === 'true') {
            setEnviada(true);
        }
    }, []);

    const siguiente = async() => {
        const campos = ['recomendacion', 'expectativas', 'satisfaccion', 'observaciones'];
        const campoActual = campos[paso];
        const respuestaActual = respuestas[campoActual].trim();

        if (!respuestaActual) {
            alert('Por favor responde antes de continuar.');
            return;
        }

        if (paso < 3) {
            setPaso(paso + 1);
        } else {
            setEnviada(true);
            localStorage.setItem('encuestaRespondida', 'true');

            try {
                await apiSafibc.post(`/encuesta/agregar-info-encuesta`,respuestas,{
                    headers: {
                        'XP1-K3Y' : `S4f1Vc`,
                        'Accept': 'application/x-www-form-urlencoded',
                        'Content-Type': 'application/x-www-form-urlencoded',
                    }
                })


            } catch (error) {
                console.log(error)
            }

        }
    };

    const anterior = () => {
        if (paso > 0) setPaso(paso - 1);
    };

    const manejarCambio = (campo) => (e) => {
        setRespuestas({ ...respuestas, [campo]: e.target.value });
    };

    const preguntas = [
        "¿Con qué probabilidad nos recomendarías a un amigo, familiar o colega?",
        "¿Qué tan bien cumplimos tus expectativas?",
        "¿Qué tan satisfecho estás con la atención recibida?",
        "¿Tienes alguna observación o comentario adicional?"
    ];

    const campos = ['recomendacion', 'expectativas', 'satisfaccion', 'observaciones'];

    return (
        <>
            <style>
                {`
          .encuesta-container {
            max-width: 500px;
            margin: 50px auto;
            background: #fff;
            border-radius: 10px;
            padding: 30px;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          }
          .encuesta-container h2 {
            text-align: center;
            color: #333;
          }
          .pregunta {
            font-size: 18px;
            margin-bottom: 15px;
            color: #444;
          }
          .rating {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            margin-top: 10px;
          }
          .rating input {
            display: none;
          }
          .rating label {
            cursor: pointer;
            padding: 10px 0;
            width: 30px;
            text-align: center;
            background-color: #f0f0f0;
            margin: 5px 2px;
            border-radius: 4px;
            transition: background-color 0.3s;
            font-weight: bold;
          }
          .rating input:checked + label {
            background-color: #4a90e2;
            color: white;
          }
          textarea {
            width: 100%;
            min-height: 100px;
            padding: 10px;
            font-size: 16px;
            border: 2px solid #ccc;
            border-radius: 6px;
            resize: vertical;
          }
          .navegacion {
            display: flex;
            justify-content: space-between;
            margin-top: 20px;
          }
          button {
            padding: 10px 20px;
            font-size: 16px;
            border: none;
            border-radius: 6px;
            background-color: #4a90e2;
            color: white;
            cursor: pointer;
            transition: background-color 0.3s;
          }
          button:disabled {
            background-color: #ccc;
            cursor: default;
          }
          button:hover:not(:disabled) {
            background-color: #357abd;
          }
          .logo-container {
            margin-top: 30px;
            text-align: center;
          }
          .logo-container img {
            max-height: 50px;
            opacity: 0.8;
          }
        `}
            </style>

            <div className="encuesta-container">
                {enviada ? (
                    <>
                        <h2>¡Gracias por responder!</h2>
                        <p>Ya has completado esta encuesta.</p>
                    </>
                ) : (
                    <>
                        <h2>Encuesta</h2>
                        <p className="pregunta">{`${paso + 1}. ${preguntas[paso]}`}</p>

                        {paso <= 2 ? (
                            <div className="rating">
                                {[...Array(10)].map((_, i) => (
                                    <React.Fragment key={i + 1}>
                                        <input
                                            type="radio"
                                            id={`${campos[paso]}_${i + 1}`}
                                            name={campos[paso]}
                                            value={i + 1}
                                            checked={respuestas[campos[paso]] === String(i + 1)}
                                            onChange={manejarCambio(campos[paso])}
                                        />
                                        <label htmlFor={`${campos[paso]}_${i + 1}`}>{i + 1}</label>
                                    </React.Fragment>
                                ))}
                            </div>
                        ) : (
                            <textarea
                                value={respuestas.observaciones}
                                onChange={manejarCambio('observaciones')}
                                placeholder="Escribe tus comentarios aquí..."
                            />
                        )}

                        <div className="navegacion">
                            <button onClick={anterior} disabled={paso === 0}>Anterior</button>
                            <button onClick={siguiente}>
                                {paso === 3 ? "Enviar" : "Siguiente"}
                            </button>
                        </div>
                    </>
                )}

                <div className="logo-container">
                    <img src="/img/logosafibc.png" alt="Logo de la empresa" />
                </div>
            </div>
        </>
    );
};

export default Encuesta;
